import React from "react";
import { useSelector, useDispatch } from 'react-redux';

import ModalCTA from '../components/library/modal/ModalCTA';
import AddPlaylist from '../components/library/form/AddPlaylist';

import {
  setModal,
  addSelectedItems
} from "../actions/index";
import {
  setTooltip
} from "../components/library/tooltip/redux/actions/index"

const useTracksToPlaylist = (items, previewPlayer = null) => {
  const dispatch = useDispatch();
  const isConnected = useSelector(state => state.isConnected);
  const storePopup = useSelector(state => state.storePopup);
  const storePlaylists = useSelector(state => state.storePlaylists);

  const addToPlaylist = (e) => {
    if (items.length > 0) {
      if (isConnected) {
        const modalNewPlaylist = (onlyCreate = true) => {
          dispatch(setModal({ // V2
            content: (
              <ModalCTA
                title={`Select a playlist`}
                styleContainer={{marginTop: `-30%`, marginLeft: `0%`}}
                styleBody={{gap: 32}}
              >
                <AddPlaylist data={items} onlyCreate={onlyCreate} />
              </ModalCTA>
            )
          }));
        }
        if (storePlaylists.playlists.length === 0) {
          storePopup.noPlaylistTransfert(modalNewPlaylist);
        } else {
          modalNewPlaylist(false);
        }
      } else {
        storePopup.playlist();
      }      
    }
  }

  const beginDnD = () => {
    const [item] = items;
    if (!item.selected) {
      const el = document.getElementById(`DI-${item.id}-TRACK`);
      if (el && !el.classList.value.includes(`selected`)) {
        el.classList.add(`selected`);
      }
    }
    dispatch(addSelectedItems(item));
    dispatch(setTooltip(null));
    previewPlayer && previewPlayer.kill();
  }

  return {
    addToPlaylist,
    beginDnD
  };
};

export default useTracksToPlaylist;
